// import { Cpu, Calendar } from "lucide-react";

// const statusStyles = {
//   Available: "bg-green-100 text-green-700",
//   Running: "bg-blue-100 text-blue-700",
//   Booked: "bg-orange-100 text-orange-700",
//   Maintenance: "bg-pink-100 text-pink-700",
// };

// export default function MachineCard({ machine }) {
//   const { code, name, technology, make, centre, hourlyRate, status } = machine;

//   return (
//     <div className="bg-white border border-gray-100 rounded-2xl p-6">
//       <div className="flex items-start justify-between mb-4">
//         <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center">
//           <Cpu className="w-5 h-5 text-white" />
//         </div>
//         <span className={`text-xs font-semibold px-3 py-1 rounded-full ${statusStyles[status]}`}>
//           {status}
//         </span>
//       </div>

//       <h3 className="font-bold text-gray-900 mb-0.5">{name}</h3>
//       <p className="text-xs text-gray-400 font-mono mb-4">{code}</p>

//       <div className="space-y-2 mb-5 text-sm">
//         <div className="flex justify-between">
//           <span className="text-gray-500">Technology</span>
//           <span className="font-medium text-gray-900">{technology}</span>
//         </div>
//         <div className="flex justify-between">
//           <span className="text-gray-500">Make</span>
//           <span className="font-medium text-gray-900">{make}</span>
//         </div>
//         <div className="flex justify-between">
//           <span className="text-gray-500">Centre</span>
//           <span className="font-medium text-gray-900">{centre}</span>
//         </div>
//         <div className="flex justify-between">
//           <span className="text-gray-500">Hourly Rate</span>
//           <span className="font-semibold text-indigo-600">₹{hourlyRate}/hr</span>
//         </div>
//       </div>

//       <div className="flex gap-3">
//         <button className="flex-1 flex items-center justify-center gap-2 bg-gradient-to-r from-indigo-600 to-blue-500 text-white text-sm font-semibold py-2.5 rounded-xl hover:opacity-90 transition">
//           <Calendar className="w-4 h-4" /> Book
//         </button>
//         <button className="flex-1 border border-gray-200 text-sm font-semibold py-2.5 rounded-xl hover:bg-gray-50 transition">
//           Details
//         </button>
//       </div>
//     </div>
//   );
// }





import { useState } from "react";
import { Cpu, Calendar } from "lucide-react";
import BookingModal from "./BookingModal";

const statusStyles = {
  Available: "bg-green-100 text-green-700",
  Running: "bg-blue-100 text-blue-700",
  Booked: "bg-orange-100 text-orange-700",
  Maintenance: "bg-pink-100 text-pink-700",
};

export default function MachineCard({ machine }) {
  const [showBooking, setShowBooking] = useState(false);
  const { code, name, technology, make, centre, hourlyRate, status } = machine;
  const isBookable = status === "Available";

  return (
    <div className="bg-white border border-gray-100 rounded-2xl p-6">
      <div className="flex items-start justify-between mb-4">
        <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center">
          <Cpu className="w-5 h-5 text-white" />
        </div>
        <span className={`text-xs font-semibold px-3 py-1 rounded-full ${statusStyles[status]}`}>
          {status}
        </span>
      </div>

      <h3 className="font-bold text-gray-900 mb-0.5">{name}</h3>
      <p className="text-xs text-gray-400 font-mono mb-4">{code}</p>

      <div className="space-y-2 mb-5 text-sm">
        <div className="flex justify-between">
          <span className="text-gray-500">Category</span>
          <span className="font-medium text-gray-900">{technology}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-500">Make</span>
          <span className="font-medium text-gray-900">{make}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-500">Hourly Rate</span>
          <span className="font-semibold text-indigo-600">₹{hourlyRate}/hr</span>
        </div>
      </div>

      <button
        type="button"
        disabled={!isBookable}
        onClick={() => setShowBooking(true)}
        className={`w-full flex items-center justify-center gap-2 text-sm font-semibold py-2.5 rounded-xl transition ${
          isBookable
            ? "bg-gradient-to-r from-indigo-600 to-blue-600 text-white hover:opacity-90"
            : "bg-gradient-to-r from-indigo-200 to-blue-200 text-white/80 cursor-not-allowed"
        }`}
      >
        <Calendar className="w-4 h-4" />
        Book this machine
      </button>

      {showBooking && (
        <BookingModal
          machine={machine}
          centre={centre}
          onClose={() => setShowBooking(false)}
          onConfirm={(booking) => {
            // TODO: wire this up to your bookings API / data layer
            console.log("Booking confirmed:", booking);
          }}
        />
      )}
    </div>
  );
}